module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-upload', {
    attrs: {
      "multiple": "",
      "drag-drop": ""
    },
    model: {
      value: (_vm.dropFiles),
      callback: function($$v) {
        _vm.dropFiles = $$v
      },
      expression: "dropFiles"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('b-icon', {
    attrs: {
      "icon": "upload",
      "size": "is-large"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Drop your files here or click to upload")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.dropFiles), function(file, index) {
    return _c('span', {
      key: index,
      staticClass: "tag is-primary"
    }, [_vm._v("\n                " + _vm._s(file.name) + "\n                "), _c('button', {
      staticClass: "delete is-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteDropFile(index)
        }
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2f11100"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/upload/examples/ExDragDrop.vue
// module id = 1285
// module chunks = 36 64